<template>
  <div>
    <section v-if="content.body.length">
      <div class="mb-2 pt-5">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="headline" v-text="content.title"></div>
          </div>
          <template>
            <div class="flex-shrink-1">
              <v-btn
                class="text-capitalize"
                text
                :color="$buttonColor"
                @click="more"
              >
                See More
                <v-icon right small>far fa-chevron-right</v-icon>
              </v-btn>
            </div>
          </template>
        </div>
        <div
          class="subtitle-1 grey--text text--darken-2"
          v-text="content.subtitle"
        ></div>
      </div>

      <v-row class="px-2 mb-4 mt-1">
        <div v-for="item in content.body" :key="item._id">
          <v-hover v-slot:default="{ hover }">
            <v-chip
              class="ma-2 hoverable"
              color="grey lighten-3"
              large
              label
              @click="navigate(item)"
            >
              <v-avatar left v-if="item.image">
                <v-img :src="item.image"></v-img>
              </v-avatar>
              <span
                class="text-capitalize"
                :style="{
                  color: [hover ? `${$themeColor}` : `rgba(0, 0, 0, 0.87)`],
                  fontSize: `16px`,
                }"
                >{{ item.title }}</span
              >
            </v-chip>
          </v-hover>
          <!-- <v-btn
          class="mr-5 my-2"
          :key="`category_${item._id}`"
          @click="navigate(item)"
        >
          <v-avatar size="20">
            <v-img :src="item.image"></v-img>
          </v-avatar>
          <div class="text-capitalize pl-2" v-text="item.title"></div>
        </v-btn> -->
        </div>
        <!-- <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn> -->
      </v-row>
    </section>
    <section v-else>
      <div class="mb-2 pt-5">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="headline" v-text="content.title"></div>
          </div>
        </div>
        <div
          class="subtitle-1 grey--text text--darken-2"
          v-text="content.subtitle"
        ></div>
      </div>
      <v-row class="px-2 mb-4 text-center body-2 grey--text">
        <v-col cols="12"> ไม่มีข้อมูล </v-col>
      </v-row>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: "category_horizontal_listview",
  props: ["content"],
  data: () => ({
    selected: null,
    iconHeight: 72,
    categories: [],
    test: [],
    listCategory: [],
  }),
  mounted() {
    this.getCategoryList();
  },
  methods: {
    getCategoryList() {
      this.listCategory = [];
      this.query = {
        page: 1,
        limit: 1000,
        sort: "title",
        sortby: 1,
      };
      this.$http
        .get(
          `${this.$store.state.api}/home/category?page=${this.query.page}&limit=${this.query.limit}&sort=${this.query.sort}&sortby=${this.query.sortby}`
        )
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == true) {
            this.listCategory = resp.data.result.elements;
          }
        })
        .catch((err) => {});
    },
    createCourseRequest() {
      let url = `${this.$store.state.api}`;
      url += `/home/category`;

      return this.$http.get(url);
    },
    navigate(item) {
      Vue.prototype.$categoryId = item._id;
      Vue.prototype.$categoryLength = this.listCategory.length;
      this.listCategory.forEach((item, index) => {
        if (Vue.prototype.$categoryId == item._id) {
          Vue.prototype.$activeItem = index;
        }
      });
      this.$router.push({
        name: "course",
        query: {
          category: item._id,
          page: 1,
          limit: 10,
          sort: "created_at",
          sortBy: -1,
          title: item.title,
        },
        params: {
          title: item.title,
          isHorizental: true,
        },
      });
    },
    more() {
      const qs = this.$utility.queryStringToJson(
        this.content.headerButton.queries
      );
      console.log(this.content.headerButton.queries);
      let sorting = this.content.headerButton.queries.filter(
        (query) => query.param == "sort"
      )[0].value;
      console.log(sorting);
      this.$router.push({
        name: "categories",
        query: {
          sort: sorting,
          sortby: -1,
          page: 1,
          limit: 10,
          title: this.content.title,
        },
      });
    },
  },
};
</script>
<style scoped>
.myCustomCardNoBorder {
  border-radius: 0px;
  border: solid 0px #dcdcdc;
  background-color: #fafafa;
  padding: 15px 15px 0px 15px;
}

.myCustomLabel {
  font-size: 16px;
  line-height: 1.38;
  color: #4a4a4a;
  min-height: 43px;
  max-height: 43px;
}
</style>
